// removed by extract-text-webpack-plugin
module.exports = {"container":"empty-section__container__3yZMW","header":"empty-section__header__1tjdA","description":"empty-section__description__2POJC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/empty-section.scss
// module id = 1414
// module chunks = 1